var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C16.0146 4 19.3385 6.95713 19.9124 10.812L17.9343 11.1093C17.5041 8.21802 15.0111 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18V20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM15.8568 16.5964L17.1429 18.1281C16.3838 18.7659 15.5043 19.2652 14.5436 19.5871L13.9074 17.6905C14.6279 17.4491 15.2874 17.0746 15.8568 16.5964ZM19.8797 13.3898L17.9099 13.0417C17.7777 13.7967 17.5044 14.5032 17.1181 15.1329L18.8242 16.1771C19.3391 15.3378 19.7034 14.3961 19.8797 13.3898Z",
    fill: "white",
    fillOpacity: 0.3
  })));
};

export { SvgLoading as ReactComponent };
export default __webpack_public_path__ + "525b23c5bbe1fc22cf5593abf6f46aa8.svg";